var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_3956)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_3956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_3956)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.6667,
    width: 9.33333,
    height: 20,
    fill: "#E3283E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.33333V0H0V20Z",
    fill: "#128A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33334C12 8.96515 11.7015 8.66668 11.3333 8.66668C10.9652 8.66668 10.6667 8.96515 10.6667 9.33334H12ZM12.329 12.2181C12.6475 12.4029 13.0555 12.2945 13.2402 11.9761C13.425 11.6576 13.3167 11.2496 12.9982 11.0649L12.329 12.2181ZM15.0757 11.0198C14.7655 11.2182 14.6749 11.6305 14.8732 11.9407C15.0716 12.2508 15.4839 12.3415 15.7941 12.1431L15.0757 11.0198ZM17.3333 9.33334C17.3333 8.96515 17.0349 8.66668 16.6667 8.66668C16.2985 8.66668 16 8.96515 16 9.33334H17.3333ZM10.6667 9.33334C10.6667 10.5664 11.3366 11.6422 12.329 12.2181L12.9982 11.0649C12.3999 10.7177 12 10.0718 12 9.33334H10.6667ZM15.7941 12.1431C16.7183 11.552 17.3333 10.5147 17.3333 9.33334H16C16 10.041 15.6329 10.6634 15.0757 11.0198L15.7941 12.1431Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.6667C14.7364 10.6667 15.3333 9.77123 15.3333 8.66666C15.3333 7.56209 14.7364 6.66666 14 6.66666C13.2636 6.66666 12.6667 7.56209 12.6667 8.66666C12.6667 9.77123 13.2636 10.6667 14 10.6667Z",
    fill: "#C59262"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_3956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMexico);
export default __webpack_public_path__ + "static/media/flag-mexico.f5f5f9f4e3a36d2516a2d6b0cfc7449f.svg";
export { ForwardRef as ReactComponent };